var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/material/styles';
import MuiRadio from '@mui/material/Radio';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var color = designTokens.color;
/**
 * Pigment [Radio](https://pigment.customink.com/?path=/docs/components-radio)
 */
var Radio = function (_a) {
    var icon = _a.icon, checkedIcon = _a.checkedIcon, _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["icon", "checkedIcon", "size"]);
    var iconSize = {
        small: {
            width: 13,
            height: 13,
        },
        medium: {
            width: 16,
            height: 16,
        },
        large: {
            width: 20,
            height: 20,
        },
    };
    var UncheckedIcon = styled('span')(function (_a) {
        var theme = _a.theme;
        var black = theme.palette.common.black;
        var grey = color.gray.disabled.value;
        return __assign(__assign({}, iconSize[size]), { border: '1.12px solid', borderRadius: '50%', borderColor: black, 'input:disabled ~ &': {
                borderColor: grey,
            }, boxSizing: 'content-box' });
    });
    var CheckedIcon = styled(UncheckedIcon)(function (_a) {
        var theme = _a.theme;
        var secondary = theme.palette.secondary.main;
        var grey = color.gray.disabled.value;
        var makeDot = function (color, size) {
            var dotSizes = {
                small: "radial-gradient(".concat(color, " 3.25px, transparent 3.35px )"),
                medium: "radial-gradient(".concat(color, " 4.5px, transparent 4.6px )"),
                large: "radial-gradient(".concat(color, " 6px, transparent 6.1px )"),
            };
            return dotSizes[size];
        };
        return {
            'input:disabled ~ &:before': {
                backgroundImage: makeDot(grey, size),
            },
            '&:before': __assign(__assign({}, iconSize[size]), { display: 'block', backgroundImage: makeDot(secondary, size), content: '""' }),
        };
    });
    return (React.createElement(MuiRadio, __assign({ checkedIcon: checkedIcon || React.createElement(CheckedIcon, null), icon: icon || React.createElement(UncheckedIcon, null), sx: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
        } }, props)));
};
export default Radio;
//# sourceMappingURL=Radio.js.map